import { TransactionFilters } from '../constants/constants';
import { IFilterOption } from '../interface/transaction';

interface AppliedFilterStateInput {
  selectedFilter: IFilterOption[];
  checkboxOptions: IFilterOption[];
  disableFilter: boolean;
  disabledCheckboxValues?: string[];
}

/**
 * Which filters show as tags and which of them the user may remove. `disableFilter` locks the radio
 * group only; checkbox options stay removable.
 */
export const getAppliedFilterState = ({
  selectedFilter,
  checkboxOptions,
  disableFilter,
  disabledCheckboxValues = [],
}: AppliedFilterStateInput) => {
  // "All" is the unfiltered state, so it never shows up as an applied filter.
  const appliedFilters = selectedFilter.filter((filter) => filter.value !== TransactionFilters.all);
  const checkboxValues = new Set(checkboxOptions.map((option) => option.value));
  const lockedCheckboxValues = new Set(disabledCheckboxValues);
  const hasAppliedCheckboxFilter = appliedFilters.some((filter) =>
    checkboxValues.has(filter.value),
  );

  const isTagLocked = (value: string) =>
    (disableFilter && !checkboxValues.has(value)) || lockedCheckboxValues.has(value);
  const isClearAllDisabled =
    (disableFilter && !hasAppliedCheckboxFilter) || lockedCheckboxValues.size > 0;

  return { appliedFilters, isTagLocked, isClearAllDisabled };
};
